import React, { useState, useEffect, useContext } from "react";
import { Label, Form, FormGroup, Row, Col, Input, InputGroup } from "reactstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { useController, useForm } from "react-hook-form";
import { formatDateTime, getCarTypes, getCorporateClientsBySeviceCityIdAndTravelType, showAlert } from "../../Services/Shared.service";
import { createPackage, createPackageRate, editPackageDetails, editPackageRateDetails, getPackageRate, getPackagesList, getTaxGroupList } from "../../Services/Packages.service";
import moment from "moment";
import { addHours, addMinutes, addSeconds, endOfDay, startOfDay, startOfHour, startOfMinute, startOfToday } from "date-fns";
import { ArrowDown, ArrowUp } from "react-feather";
import CustomSelect from "../../CommonElements/CustomSelect";
import CustomizerContext from "../../_helper/Customizer";
import { CommonModal } from "../../AbstractElements";

const PackageRateInput = ({ editId, isOpen, toggleModal, packagesData, selectedPackage }) => {
    const {
        register,
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        getValues,
        reset
    } = useForm({
        defaultValues: {
            package: "",
            minPkgDistance: "",
            pkgDistance: "",
            pkgTimeInMin: "",
            pkgCharge: "",
            addnlPerKmCharge: "",
            addnlTimeCharge: "",
            addnlTimeChargeBlockInMin: "",
            isTaxInclusive: false,
            timeFrom: "",
            timeTo: "",
            isTimeBased: false,
            maxPkgDistance: "",
            packageValue: "",
            isNightfareTimeSlot: false,
            packageRideType: ""
        },
    });
    const values = getValues()
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [isAdvanced, setIsAdvanced] = useState(false)
    const { mix_background_layout } = useContext(CustomizerContext)
    const [packageRateObj, setPackageRateObj] = useState({})

    const isTaxInclusiveField = useController({
        name: "isTaxInclusive",
        control,
    }).field;

    const isTimeBasedField = useController({
        name: "isTimeBased",
        control,
    }).field;

    const isNightfareTimeSlotField = useController({
        name: "isNightfareTimeSlot",
        control,
    }).field;

    const packageField = useController({
        name: "package",
        control,
        rules: {
            required: {
                value: true,
                message: "Package is Required",
            },
        },
    }).field;

    const handlePackageField = (data) => {
        packageField.onChange(data.value)
    }

    // const packageRideTypeField = useController({
    //     name: "packageRideType",
    //     control,
    //     rules: {
    //         required: {
    //             value: true,
    //             message: "Package is Required",
    //         },
    //     },
    // }).field;

    // const handlePackageRideTypeSelectChange = (data) => {
    //     packageRideTypeField.onChange(data.value);
    // };

    const addnlTimeChargeBlockInMinField = useController({
        name: "addnlTimeChargeBlockInMin",
        control,
        rules: {
            required: {
                value: true,
                message: "Extra Time Block (in hours) is Required",
            },
        },
    }).field;

    const handleAddnlTimeChargeBlockInMin = (data) => {
        addnlTimeChargeBlockInMinField.onChange(data);
    };

    const pkgTimeInMinField = useController({
        name: "pkgTimeInMin",
        control,
        rules: {
            required: {
                value: true,
                message: "Package Hours is Required",
            },
        },
    }).field;

    const handlePkgTimeInMinDate = (data) => {
        pkgTimeInMinField.onChange(data);
    };

    const timeFromField = useController({
        name: "timeFrom",
        control,
        rules: {
            required: {
                value: isTimeBasedField.value ? true : false,
                message: "Applicable From is Required",
            },
        },
    }).field;

    const handleTimeFrom = (data) => {
        timeFromField.onChange(data);
    };

    const timeToField = useController({
        name: "timeTo",
        control,
        rules: {
            required: {
                value: isTimeBasedField.value ? true : false,
                message: "Applicable To is Required",
            },
        },
    }).field;

    const handleTimeTo = (data) => {
        timeToField.onChange(data);
    };

    useEffect(()=>{
        if(selectedPackage.id){
            packageField.onChange({ id: selectedPackage.id, name: selectedPackage.name })
        }
    },[selectedPackage])

    useEffect(() => {
        if (editId) {
            getPackageRate({ packageId: editId }).then((result) => {
                setPackageRateObj(result.data)
                reset({
                    package: result.data.packagesId ? { id: result.data.packagesId, name: result.data.packagesName } : 0,
                    minPkgDistance: result.data.minPkgDistance ? result.data.minPkgDistance : 0,
                    pkgDistance: result.data.pkgDistance ? result.data.pkgDistance : 0,
                    pkgTimeInMin: result.data.pkgTimeInMin ? addMinutes(new Date().setHours(0, 0, 0, 0), result.data.pkgTimeInMin) : 0,
                    pkgCharge: result.data.pkgCharge ? result.data.pkgCharge : 0,
                    addnlPerKmCharge: result.data.addnlPerKmCharge ? result.data.addnlPerKmCharge : 0,
                    addnlTimeCharge: result.data.addnlTimeCharge ? result.data.addnlTimeCharge : 0,
                    addnlTimeChargeBlockInMin: result.data.addnlTimeChargeBlockInMin ? addMinutes(new Date().setHours(0, 0, 0, 0), result.data.addnlTimeChargeBlockInMin) : 0,
                    isTaxInclusive: result.data.isTaxInclusive ? result.data.isTaxInclusive : false,
                    timeFrom: result.data.timeFrom ? addSeconds(new Date().setHours(0, 0, 0, 0), result.data.timeFrom) : "",
                    timeTo: result.data.timeTo ? addSeconds(new Date().setHours(0, 0, 0, 0), result.data.timeTo) : "",
                    isTimeBased: result.data.isTimeBased ? result.data.isTimeBased : false,
                    maxPkgDistance: result.data.maxPkgDistance ? result.data.maxPkgDistance : 0,
                    packageValue: result.data.packageValue ? result.data.packageValue : 0,
                    isNightfareTimeSlot: result.data.isNightfareTimeSlot ? result.data.isNightfareTimeSlot : false,
                    packageRideType: result.data.packageRideType ? result.data.packageRideType : 0,
                })
            }).catch((err) => {
                showAlert("error", err.response?.data?.message
                    ? err.response.data.message : "Something went wrong");
            });
        }
    }, [editId])

    console.log("values", values)

    const rideTypeDatas = [
        { label: "All", value: "All" },
        { label: "AirportToCity", value: "AirportToCity" },
        { label: "CityToAirport", value: "CityToAirport" },
        { label: "CityToCity", value: "CityToCity" }
    ]

    const onFormSubmit = (formValues) => {
        setIsSubmitting(true)
        console.log("form values", formValues);
        const body = {
            packagesId: Number(formValues.package.id),
            minPkgDistance: formValues.minPkgDistance ? Number(formValues.minPkgDistance) : 0,
            pkgDistance: formValues.pkgDistance ? Number(formValues.pkgDistance) : 0,
            pkgTimeInMin: formValues.pkgTimeInMin ? Number(moment.duration(moment(formValues.pkgTimeInMin).format("HH:mm:ss")).asMinutes()) : 0,
            pkgCharge: formValues.pkgCharge ? Number(formValues.pkgCharge) : 0,
            addnlPerKmCharge: formValues.addnlPerKmCharge ? Number(formValues.addnlPerKmCharge) : 0,
            addnlTimeCharge: formValues.addnlTimeCharge ? Number(formValues.addnlTimeCharge) : 0,
            addnlTimeChargeBlockInMin: formValues.addnlTimeChargeBlockInMin ? Number(moment.duration(moment(formValues.addnlTimeChargeBlockInMin).format("HH:mm:ss")).asMinutes()) : 0,
            isTaxInclusive: formValues.isTaxInclusive ? true : false,
            timeFrom: formValues.timeFrom ? Number(moment.duration(moment(formValues.timeFrom).format("HH:mm:ss")).asSeconds()) : 0,
            timeTo: formValues.timeTo ? Number(moment.duration(moment(formValues.timeTo).format("HH:mm:ss")).asSeconds()) : 86400,
            // timeFrom: 0,
            // timeTo: 0,
            isTimeBased: formValues.isTimeBased ? true : false,
            maxPkgDistance: formValues.maxPkgDistance ? Number(formValues.maxPkgDistance) : 0,
            packageValue: formValues.packageValue ? Number(formValues.packageValue) : 0,
            isNightfareTimeSlot: formValues.isNightfareTimeSlot ? true : false,
            packageRideType: formValues.packageRideType
        };
        createPackageRate(body)
            .then((result) => {
                reset({
                    package: "",
                    minPkgDistance: "",
                    pkgDistance: "",
                    pkgTimeInMin: "",
                    pkgCharge: "",
                    addnlPerKmCharge: "",
                    addnlTimeCharge: "",
                    addnlTimeChargeBlockInMin: "",
                    isTaxInclusive: false,
                    timeFrom: "",
                    timeTo: "",
                    isTimeBased: false,
                    maxPkgDistance: "",
                    packageValue: "",
                    isNightfareTimeSlot: false,
                    packageRideType: ""
                })
                showAlert("success", "Package Rate Created Successfully");
                setIsSubmitting(false)
                toggleModal()
            })
            .catch((err) => {
                showAlert("error", err.response?.data?.message
                    ? err.response.data.message : "Something went wrong");
                setIsSubmitting(false)
            });
    };
    const handleTime_To=(time,constraint)=>{
            let timeto= constraint=="S" ? Number(moment.duration(moment(time).format("HH:mm:ss")).asSeconds()) : Number(moment.duration(moment(time).format("HH:mm:ss")).asMinutes()); 
            if(timeto===0 && constraint=="S"){
                return 86400;
            }
            else if(timeto===0 && constraint=="M"){
                return 1440;
            }
            return timeto;
        }
    const onEditSubmit = (formValues) => {
        setIsSubmitting(true)
        console.log("form values", formValues);
        const body = {
            id: packageRateObj.id,
            packagesId: Number(formValues.package.id),
            minPkgDistance: formValues.minPkgDistance ? Number(formValues.minPkgDistance) : 0,
            pkgDistance: formValues.pkgDistance ? Number(formValues.pkgDistance) : 0,
            pkgTimeInMin: formValues.pkgTimeInMin ? handleTimeTo(formValues.pkgTimeInMin,"M"): 0,
            pkgCharge: formValues.pkgCharge ? Number(formValues.pkgCharge) : 0,
            addnlPerKmCharge: formValues.addnlPerKmCharge ? Number(formValues.addnlPerKmCharge) : 0,
            addnlTimeCharge: formValues.addnlTimeCharge ? Number(formValues.addnlTimeCharge) : 0,
            addnlTimeChargeBlockInMin: formValues.addnlTimeChargeBlockInMin ? Number(moment.duration(moment(formValues.addnlTimeChargeBlockInMin).format("HH:mm:ss")).asMinutes()) : 0,
            isTaxInclusive: formValues.isTaxInclusive ? true : false,
            timeFrom: formValues.timeFrom ? Number(moment.duration(moment(formValues.timeFrom).format("HH:mm:ss")).asSeconds()) : 0,
            timeTo: formValues.timeTo ? handleTime_To(formValues.timeTo,"S") : 86400,
            // timeFrom: 0,
            // timeTo: 0,
            isTimeBased: formValues.isTimeBased ? true : false,
            maxPkgDistance: formValues.maxPkgDistance ? Number(formValues.maxPkgDistance) : 0,
            packageValue: formValues.packageValue ? Number(formValues.packageValue) : 0,
            isNightfareTimeSlot: formValues.isNightfareTimeSlot ? true : false,
            packageRideType: formValues.packageRideType
        };
        editPackageRateDetails(body)
            .then((result) => {
                reset({
                    package: "",
                    minPkgDistance: "",
                    pkgDistance: "",
                    pkgTimeInMin: "",
                    pkgCharge: "",
                    addnlPerKmCharge: "",
                    addnlTimeCharge: "",
                    addnlTimeChargeBlockInMin: "",
                    isTaxInclusive: false,
                    timeFrom: "",
                    timeTo: "",
                    isTimeBased: false,
                    packageValue: "",
                    isNightfareTimeSlot: false,
                })
                showAlert("success", "Package Rate Details Updated Successfully");
                setIsSubmitting(false)
                toggleModal()
                setPackageRateObj({})
            })
            .catch((err) => {
                showAlert("error", err.response?.data?.message
                    ? err.response.data.message : "Something went wrong");
                setIsSubmitting(false)
            });
    }

    return (
        <CommonModal
            isOpen={isOpen}
            title={editId ? "Edit Package Rate" : "Create Package Rate"}
            toggler={() => {
                reset({
                    package: "",
                    minPkgDistance: "",
                    pkgDistance: "",
                    pkgTimeInMin: "",
                    pkgCharge: "",
                    addnlPerKmCharge: "",
                    addnlTimeCharge: "",
                    addnlTimeChargeBlockInMin: "",
                    isTaxInclusive: false,
                    timeFrom: "",
                    timeTo: "",
                    isTimeBased: false,
                    packageValue: "",
                    isNightfareTimeSlot: false,
                })
                setPackageRateObj({})
                toggleModal()
            }}
            size="xl"
        >
            <Form onSubmit={handleSubmit(packageRateObj?.id ? onEditSubmit : onFormSubmit)}>
                <Row>
                    <FormGroup className="col-lg-4">
                        <Label className="col-lg-12 col-form-label">Package</Label>
                        <Col lg="12">
                            <div className="city-select">
                                <CustomSelect
                                    className="service-select"
                                    classNamePrefix="select"
                                    isClearable={false}
                                    isSearchable={false}
                                    isDisabled={editId ? true : false}
                                    value={packageField?.value?.id ? packagesData.find((element) => {
                                        return element?.value?.id === packageField?.value?.id;
                                    }) : ""}
                                    //   // defaultValue={cityData.find((element) => {
                                    //   //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
                                    //   //   return element?.value?.id === cityField?.value?.id;
                                    //   // })}
                                    
                                    onChange={handlePackageField}
                                    placeholder="Select Package"
                                    options={packagesData}
                                />
                            </div>
                            <span style={{ color: "red" }}>{errors?.package?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-4">
                        <Label className="col-lg-12 col-form-label">Minimum Distance</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                pattern="[0-9.]+"
                                {...register("minPkgDistance", {
                                    required: {
                                        value: true,
                                        message: "Minimum Distance is required",
                                    },
                                    onChange: (e) => {
                                        setValue("minPkgDistance", e.target.value.replace(/[^0-9.]/g, ''))
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.minPkgDistance?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-4">
                        <Label className="col-lg-12 col-form-label">Maximum Distance</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                pattern="[0-9.]+"
                                {...register("maxPkgDistance", {
                                    required: {
                                        value: true,
                                        message: "Maximum Distance is required",
                                    },
                                    onChange: (e) => {
                                        setValue("maxPkgDistance", e.target.value.replace(/[^0-9.]/g, ''))
                                        setValue("pkgDistance", e.target.value.replace(/[^0-9.]/g, ''))
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.maxPkgDistance?.message}</span>
                        </Col>
                    </FormGroup>
                    {/* <FormGroup className="col-lg-4">
                        <Label className="col-lg-12 col-form-label">Total Distance</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                pattern="[0-9.]+"
                                {...register("pkgDistance", {
                                    required: {
                                        value: true,
                                        message: "Total Distance is required",
                                    },
                                    onChange: (e) => {
                                        setValue("pkgDistance", e.target.value.replace(/[^0-9.]/g, ''))
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.pkgDistance?.message}</span>
                        </Col>
                    </FormGroup> */}
                    <FormGroup className="col-lg-4">
                        <Label className="col-lg-12 col-form-label">Package Fee</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                pattern="[0-9.]+"
                                {...register("pkgCharge", {
                                    required: {
                                        value: true,
                                        message: "Package Fee is required",
                                    },
                                    onChange: (e) => {
                                        setValue("pkgCharge", e.target.value.replace(/[^0-9.]/g, ''))
                                        setValue("packageValue", e.target.value.replace(/[^0-9.]/g, ''))
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.pkgCharge?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-4">
                        <Label className="col-lg-12 col-form-label">Per Km Charge</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                pattern="[0-9.]+"
                                {...register("addnlPerKmCharge", {
                                    required: {
                                        value: true,
                                        message: "Per Km Charge is required",
                                    },
                                    onChange: (e) => {
                                        setValue("addnlPerKmCharge", e.target.value.replace(/[^0-9.]/g, ''))
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.addnlPerKmCharge?.message}</span>
                        </Col>
                    </FormGroup>
                    {/* <FormGroup className="col-lg-4" style={{ display: "flex", alignItems: "center" }}>
                        <div style={{ display: "flex", alignItems: "center" }} className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"}>
                            <Input id="IsTaxInclusive" type="checkbox" checked={isTaxInclusiveField.value}
                                onChange={(value) => isTaxInclusiveField.onChange(value)} />
                            <Label className="mb-0" for="IsTaxInclusive">Including Tax</Label>
                        </div>
                    </FormGroup> */}
                    <FormGroup className="col-lg-4" style={{ display: "flex", alignItems: "center" }}>
                        <div className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"} style={{ display: "flex", alignItems: "center" }}>
                            <Input
                                id="IsTimeBased"
                                type="checkbox"
                                checked={isTimeBasedField.value}
                                onChange={(value) => isTimeBasedField.onChange(value)}
                            />
                            <Label className="mb-0" for="IsTimeBased" >Time Based</Label>
                        </div>
                    </FormGroup>
                    {/* <FormGroup className="col-lg-4">
                        <Label className="col-lg-12 col-form-label">Package Hours</Label>
                        <Col lg="12">
                            <InputGroup className="date" id="dt-minimum" data-target-input="nearest">
                                <DatePicker
                                    className="form-control datetimepicker-input digits"
                                    selected={pkgTimeInMinField.value}
                                    onChange={handlePkgTimeInMinDate}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={60}
                                    timeCaption="Time"
                                    dateFormat="H:mm"
                                    timeFormat="H:mm"
                                    onKeyDown={(e) => {
                                        e.preventDefault();
                                    }}
                                />
                            </InputGroup>
                            <span style={{ color: "red" }}>{errors?.pkgTimeInMin?.message}</span>
                        </Col>
                    </FormGroup> */}
                    <FormGroup className="col-lg-4">
                        <Label className="col-lg-12 col-form-label">Extra Time Charge</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                pattern="[0-9.]+"
                                {...register("addnlTimeCharge", {
                                    required: {
                                        value: true,
                                        message: "Extra Time Charge is required",
                                    },
                                    onChange: (e) => {
                                        setValue("addnlTimeCharge", e.target.value.replace(/[^0-9.]/g, ''))
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.addnlTimeCharge?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-4">
                        <Label className="col-lg-12 col-form-label">Extra Time Block (in hours)</Label>
                        <Col lg="12">
                            <DatePicker
                                className="form-control datetimepicker-input digits"
                                selected={addnlTimeChargeBlockInMinField.value}
                                onChange={handleAddnlTimeChargeBlockInMin}
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={60}
                                timeCaption="Time"
                                dateFormat="H:mm"
                                timeFormat="H:mm"
                                onKeyDown={(e) => {
                                    e.preventDefault();
                                }}
                            />
                            {/* <input
                        className="form-control"
                        type="number"
                        step={"any"}
                        {...register("addnlTimeChargeBlockInMin", {})}
                    /> */}
                            <span style={{ color: "red" }}>{errors?.addnlTimeChargeBlockInMin?.message}</span>
                        </Col>
                    </FormGroup>


                    {isTimeBasedField.value ? <>
                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">Time From (Hours)</Label>
                            <Col lg="12">
                                <InputGroup className="date" id="dt-minimum" data-target-input="nearest">
                                    <DatePicker
                                        className="form-control datetimepicker-input digits"
                                        selected={timeFromField.value}
                                        onChange={handleTimeFrom}
                                        showTimeSelect
                                        showTimeSelectOnly
                                        timeIntervals={60}
                                        timeCaption="Time"
                                        dateFormat="H:mm"
                                        timeFormat="H:mm"
                                        onKeyDown={(e) => {
                                            e.preventDefault();
                                        }}

                                    />
                                </InputGroup>
                                <span style={{ color: "red" }}>{errors?.timeFrom?.message}</span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">Time To (Hours)</Label>
                            <Col lg="12">
                                <InputGroup className="date" id="dt-minimum" data-target-input="nearest">
                                    <DatePicker
                                        className="form-control datetimepicker-input digits"
                                        selected={timeToField.value}
                                        onChange={handleTimeTo}
                                        showTimeSelect
                                        showTimeSelectOnly
                                        timeIntervals={60}
                                        timeCaption="Time"
                                        dateFormat="H:mm"
                                        timeFormat="H:mm"
                                        onKeyDown={(e) => {
                                            e.preventDefault();
                                        }}
                                    />
                                </InputGroup>
                                <span style={{ color: "red" }}>{errors?.timeTo?.message}</span>
                            </Col>
                        </FormGroup>
                    </> : null}
                    <FormGroup className="col-lg-4">
                        <Label className="col-lg-12 col-form-label">Package Amount</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                pattern="[0-9.]+"
                                {...register("packageValue", {
                                    required: {
                                        value: true,
                                        message: "Package Value is required",
                                    },
                                    onChange: (e) => {
                                        setValue("packageValue", e.target.value.replace(/[^0-9.]/g, ''))
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.packageValue?.message}</span>
                        </Col>
                    </FormGroup>
                    {/* <FormGroup className="col-lg-12">
                <div className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"}>
                    <Input
                        id="IsNightfareTimeSlot"
                        type="checkbox"
                        checked={isNightfareTimeSlotField.value}
                        onChange={(value) => isNightfareTimeSlotField.onChange(value)}
                    />
                    <Label className="mb-0" for="IsNightfareTimeSlot" >Night Fare</Label>
                </div>
            </FormGroup> */}
                    {/* <FormGroup className="col-lg-4">
                        <Label className="col-lg-12 col-form-label">Package Ride Type</Label>
                        <Col lg="12">
                            <div className="city-select">
                                <CustomSelect
                                    className="service-select"
                                    classNamePrefix="select"
                                    isClearable={false}
                                    isSearchable={false}
                                    value={packageRideTypeField?.value ? rideTypeDatas.find((element) => {
                                        return element?.value === packageRideTypeField?.value;
                                    }) : ""}
                                    // defaultValue={cityData.find((element) => {
                                    //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
                                    //   return element?.value?.id === cityField?.value?.id;
                                    // })}
                                    onChange={handlePackageRideTypeSelectChange}
                                    placeholder="Select Package Ride Type"
                                    options={rideTypeDatas}
                                />
                            </div>
                            <span style={{ color: "red" }}>{errors?.packageRideType?.message}</span>
                        </Col>
                    </FormGroup> */}

                </Row>
                {/* <Row>
                <div style={{ color: "#2F3293", textDecoration: "underline", display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => setIsAdvanced(!isAdvanced)}>Advanced Configurations {isAdvanced ? <ArrowUp style={{ width: "15px", height: "15px", marginLeft: "5px" }} /> : <ArrowDown style={{ width: "15px", height: "15px", marginLeft: "5px" }} />}</div>
            </Row> */}
                {/* {isAdvanced ? <Row>
                

            </Row> : null} */}
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <button type="submit" className="btn submit-button" disabled={isSubmitting}>
                        {packageRateObj?.id ? "Update" : "Create"}
                    </button>
                </div>
            </Form>
        </CommonModal>
    )
}

export default PackageRateInput